var _defs, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_74817",
    "data-name": "Group 74817",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13834",
    "data-name": "Rectangle 13834",
    width: 15.472,
    height: 15.472,
    fill: "#185edf",
    stroke: "#707070",
    strokeWidth: 1
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5504",
    "data-name": "Ellipse 5504",
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#e8eaee"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28603",
    "data-name": "Group 28603",
    transform: "translate(3.113 3.112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_869",
    "data-name": "Mask Group 869",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13833",
    "data-name": "Rectangle 13833",
    width: 15.472,
    height: 15.472,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2",
    transform: "translate(1.459 1.284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18988",
    "data-name": "Path 18988",
    d: "M14.2,6.27,9.655,1.693a.612.612,0,0,0-.9,0L1.693,8.752A.645.645,0,0,0,1.5,9.2v4.545a.645.645,0,0,0,.645.645H6.69a.645.645,0,0,0,.451-.193L14.2,7.172a.612.612,0,0,0,0-.9ZM6.432,13.1H2.789V9.461l4.029-4,3.61,3.642Zm4.932-4.9L7.721,4.561,9.2,3.046l3.642,3.675Z",
    transform: "translate(-1.5 -1.494)",
    fill: "#185edf"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/Edit-icon.616436e46d7a49608841adb55acb27ae.svg";
export { ForwardRef as ReactComponent };